import Swal from 'sweetalert2';

const swalUtils = {
    success: (title, text) => {
        return Swal.fire({
            icon: 'success',
            title: title || 'Success',
            text: text || '',
            confirmButtonColor: '#3085d6',
        });
    },

    error: (title, text) => {
        return Swal.fire({
            icon: 'error',
            title: title || 'Error',
            text: text || 'Something went wrong!',
            confirmButtonColor: '#d33',
        });
    },

    warning: (title, text) => {
        return Swal.fire({
            icon: 'warning',
            title: title || 'Warning',
            text: text || '',
            confirmButtonColor: '#f8bb86',
        });
    },

    confirm: (title, text, confirmButtonText = 'Yes', cancelButtonText = 'No') => {
        return Swal.fire({
            title: title || 'Are you sure?',
            text: text || "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: confirmButtonText,
            cancelButtonText: cancelButtonText
        });
    }
};

export default swalUtils;
